import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PreInitSettingsService } from './settings/pre-init-setting.service';
import { AddressValidationResponseDto } from 'src/app/model/account/address-validation-response.dto';
import { ContractContactAddress } from 'src/app/model/account/user-otp-request';
import { SaveAddressRequest } from 'src/app/model/account/save-address-request.dto';

@Injectable({
  providedIn: 'root'
})
export class AddressValidationService {
  url: string;

  constructor(
    private preInitSettingsService: PreInitSettingsService,
    private httpClient: HttpClient
  ) {
    this.url = this.preInitSettingsService.getSettings().middleWare.middlewareUrl + this.preInitSettingsService.getSettings().middleWare.accountPath;
  }

  validateAddress(address: ContractContactAddress): Observable<AddressValidationResponseDto> {
    return this.httpClient.post<AddressValidationResponseDto>(this.url + 'validate-address', address);
  }

  /**
   * Persists the address against the contract found by `primaryEmail` / `phone`.
   * Callers MUST populate at least one of those two — see `SaveAddressRequest`.
   */
  saveAddress(request: SaveAddressRequest): Observable<AddressValidationResponseDto> {
    return this.httpClient.post<AddressValidationResponseDto>(this.url + 'save-address', request);
  }
}
